module.exports = "/_next/static/images/blue_chip_pool-691d322e457b29fba9e991d19fefb81b.svg";